const siteThemes = {
  kids: {
    classes: {
      pageHeading: "bg-primary",
      loginFormTitle: "text-white",
    },
    images: {
      logo: {
        desktop: "logo-kids.svg",
        mobile: "logo-kids.svg",
      },
      logoBanner: "banner-kids.svg",
    },
  },
  default: {
    classes: {
      pageHeading: "bg--gradient",
      loginFormTitle: "text-white",
    },
    images: {
      logo: {
        desktop: "logo-white.svg",
        mobile: "logo-green.svg",
      },
      logoBanner: "banner.svg",
    },
  },
};

export default siteThemes[config.VITE_THEME] || siteThemes.default;
